<header class="main-header sticky-top">
  <nav class="navbar navbar-light navbar-expand-lg top-navbar bg-white shadow-sm">
    <div class="container-fluid">
      <div class="navbar-brand py-4"><img src="/assets/images/logotipo-rg-punto-a-punto.svg" alt="Punto a punto"
          class="logo-header"></div>
    </div>
  </nav>
</header>

<app-conditions-accept-text></app-conditions-accept-text>

<div class="container legal-text-container legal-text">
  <div class="custom-button-group align-right mt-5">
    <div class="form-check form-switch form-switch-right">
      <input [(ngModel)]="acceptCrm" class="form-check-input" type="checkbox" id="acceptCrmSwitch">
      <label class="form-check-label" for="acceptCrmSwitch">Quiero recibir comunicaciones comerciales de Renault España
        Comercial a través de Punto a Punto.</label>
    </div>
  </div>
  <div *ngIf="!loading" class="custom-button-group align-right mt-1">
    <div class="form-check form-switch form-switch-right">
      <input [(ngModel)]="acceptCrmR1" class="form-check-input" type="checkbox" id="acceptCrmR1Switch">
      <label class="form-check-label" for="acceptCrmR1Switch">Quiero recibir comunicaciones comerciales de mi
        concesionario Renault/Dacia con el que mantengo una relación comercial a través del programa Punto a
        Punto.</label>
    </div>
  </div>
  <div *ngIf="!loading" class="custom-button-group align-right mt-5">
    <button class="btn-black-border" (click)="cancel()">Cancelar</button>
    <button class="btn-dimgrey" (click)="setConditions()">Aceptar condiciones</button>
  </div>
</div>